export default __webpack_public_path__ + "static/media/linkb.9a83fe41.svg";